import http from "@/settings/apiSettings"

class SarbatoriLegaleService {
    save(data: any) : Promise<any> {
        return http.clientResurseUmaneOdata.post("/RU_SarbatoriLegale", data)
    }
}
export default new SarbatoriLegaleService()